import { FC, ReactNode } from "react";
import { Switch, SwitchSize } from "shared/components/forms/Switch";
import { CheckComponent } from "./CheckComponent";

export const SwitchWithReadOnlyMode: FC<{
  checked: boolean;
  label?: ReactNode;
  onChange: (v: boolean) => void;
  disabled?: boolean;
  readOnly?: boolean;
  className?: string;
}> = ({
  className,
  checked,
  label,
  onChange,
  disabled = false,
  readOnly = false
}) => {
  return (
    <div className="py-2">
      {readOnly ? (
        <CheckComponent checked={checked} label={label} />
      ) : (
        <Switch
          onChange={onChange}
          checked={checked}
          disabled={disabled}
          label={label}
          size={SwitchSize.SM}
          className="text-base text-content-1000 font-medium"
        />
      )}
    </div>
  );
};
